import IRepresentativeRepository from 'domain/interfaces/repositories/IAuthUserRepository'

export const refreshTokenRepresentativeCommand = (
  repository: IRepresentativeRepository,
  token: string,
) => {
  return repository.refreshToken(token)
}
